<template>
  <div class="emh-side-filters-stock_type-category">
    <emh-side-filters-category-filter-template
      v-for="filter in multiselectCategoryFilters"
      :key="filter.name"
      :title="filterCategory.hideFilterTitles ? undefined : filter.name"
      :filter-counter="getSelectedCategoryFilterCounter(filter)"
      data-test-id="emh-side-filters-stock_type-category__stock_type-template"
      @clear-category="onClearCategory(filter)"
    >
      <ui-multiselect-group
        class="emh-side-filters-stock_type-category__multiselect-options"
        :options="filter.options"
        data-test-id="emh-side-filters-stock_type-category__stock_type-options"
        @select-option="filter.handleChange"
      />
    </emh-side-filters-category-filter-template>
  </div>
</template>

<script lang="ts">
export default {
  name: 'EmhSideFiltersStockTypeCategory',
};
</script>

<script lang="ts" setup>
import { computed, PropType, toRefs } from 'vue';
import {
  getSelectedCategoryFilterCounter,
  useMultiselectFilterCategories,
} from '../../../composables/filter-categories.composable';
import EmhSideFiltersCategoryFilterTemplate from '../sideFiltersCategoryFilterTemplate/SideFiltersCategoryFilterTemplate.vue';
import UiMultiselectGroup from '@dh-io-emh/ui/src/form/multiselectGroup/MultiselectGroup.vue';

import {
  IProductFilterGroup,
  ProductFilterTypes,
} from '@dh-io-emh/shared/src/models/product-filter/product-filter-base.model';

const props = defineProps({
  filterCategory: {
    type: Object as PropType<IProductFilterGroup>,
    required: true,
  },
});

const emit = defineEmits(['change', 'clear-category']);

console.log('DEBUGGER');

const { filterCategory } = toRefs(props);

const multiselectFilters = computed(() =>
  filterCategory?.value.filters.filter(({ type }) => type === ProductFilterTypes.MultiSelect),
);

const multiselectCategoryFilters = useMultiselectFilterCategories({
  filterCategory: computed(() => ({ ...filterCategory?.value, filters: multiselectFilters.value })),
  emit,
});

const onClearCategory = (filterOption) => emit('clear-category', [filterOption.code]);
</script>

<style lang="scss" scoped>
.emh-side-filters-stock_type-category {
  &__multiselect-options {
    grid-template-columns: repeat(2, minmax(72px, 1fr));
  }
}
</style>
